import Pen from '@assets/icons/pen.svg'
import { Icon } from './Icon'

export const PenIcon = Icon(Pen)
